import styled from "styled-components";

function BackgroundBlock({ children }) {
    return (
        <BlockBody>
            {children}
        </BlockBody>
    );
}

const BlockBody = styled.main`
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 20px;
    border-radius: 10px;
    background-color: #f8fafc;
    width: 100%;
    padding: 15px;
    margin-top: 10px;
    min-height: calc(100vh - 140px);
    overflow-y: auto;
`;

export default BackgroundBlock;
